import React, { Component } from 'react'
import { connect } from 'react-redux'
import ProductPrice from './ProductPrice'
import { addPrice } from './products-reducer'

class ProductPriceContainer extends Component {
  constructor (props) {
    super(props)
    this.handlePriceAdded = this.handlePriceAdded.bind(this)
  }

  // attach the new prices to the product and update it here
  handlePriceAdded (date, price) {
    this.props.addPrice(this.props.product._id, date, price)
  }

  render () {
    const {
      product,
      requestOngoing
    } = this.props

    return <div>
      <h4>{product.name} Price</h4>
      <ProductPrice
        product={product}
        onPriceAdded={this.handlePriceAdded}
        requestOngoing={requestOngoing}
      />
    </div>
  }
}

const mapStateToProps = ({products: {products, requestOngoing}}, { match: { params } }) => ({
  product: products.filter(product => product._id === decodeURIComponent(params.productId))[0],
  requestOngoing
})

const mapDispatchToProps = {
  addPrice
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPriceContainer)



// WEBPACK FOOTER //
// ./src/products/ProductPriceContainer.js